import React, { useState, useEffect } from "react";
import {
  Layout,
  Button,
  Modal,
  Input,
  Checkbox,
  Table,
  Pagination,
  Tooltip,
  message,
  Form,
  Space,
  Popconfirm,
} from "antd";
import { withRouter, Link } from "react-router-dom";
import "./userManagement.less";
import { axiosPost, newAjaxApi } from "@/server/index";
import common from "@/public/common";
import { getFormatDate, getCookieNew, md5hex } from "@/public/utils";
import { MailOutlined } from "@ant-design/icons";
const CheckboxGroup = Checkbox.Group;

const UserManagement = (props) => {
  const [form] = Form.useForm();
  const [searchForm] = Form.useForm();
  const [page, setPage] = useState({
    pagesize: 20,
    pageindex: 1,
  });
  const [phone_cut_count, setphone_cut_count] = useState(60);
  const [total, setTotal] = useState(0);
  const [userList, setUserList] = useState([]);
  const [modalVisiable, setModalVisiable] = useState(false);
  const [helpVisiable, setHelpVisiable] = useState(false);
  const [options] = useState([
    { label: "启用", value: 1 },
    { label: "停用", value: 0 },
  ]);
  const [companyInfo, setCompanyInfo] = useState("");
  const confirm = async (e) => {
    let res = await axiosPost(
      common.eurekaUrlDic + "/account/scs-login/account-enterprise/update",
      {
        operate_account_id: getCookieNew("accountId"),
        id: e.accountEnterpriseId,
        is_delete: true,
      },
    );
    if (res.data.code == 200) {
      message.success("移除成功");
      setPage({
        ...page,
        pageindex: 1,
      });
    }
  };
  const roleColumns = [
    {
      title: "用户名",
      width: 250,
      dataIndex: "username",
      key: "username",
    },
    {
      title: "真实姓名",
      width: 250,
      dataIndex: "reallyname",
      key: "reallyname",
    },
    {
      title: "角色",
      key: "roleid",
      width: 250,
      render: (text) => {
        return text.rolename ? (
          <Tooltip placement="topLeft" title={getRoleName(text.rolename)}>
            {getRoleName(text.rolename).length > 10
              ? getRoleName(text.rolename).substring(0, 10) + "..."
              : getRoleName(text.rolename).substring(0, 10)}
          </Tooltip>
        ) : (
          ""
        );
      },
    },
    // {
    //   title: "状态",
    //   key: "status",
    //   render: (text) => {
    //     return text.status == "1" ? "启用" : "停用";
    //   },
    // },
    {
      title: "最近编辑人",
      key: "modifyname",
      render: (text) => {
        return text.modifyname;
      },
    },
    {
      title: "最近编辑时间",
      key: "modifytime",
      render: (text) => {
        return text.modifytime != null ? getFormatDate(text.modifytime) : "";
      },
    },
    {
      title: "操作",
      key: "option",
      render: (text, record) => {
        return (
          <Space>
            <Link
              to={{
                pathname: "/main/authorityManagement/setRole",
                state: { userData: text },
              }}
              className="blue"
            >
              设置角色
            </Link>
            {!record.isPan && (
              <Popconfirm
                title="是否确认移除该用户?"
                onConfirm={() => {
                  confirm(record);
                }}
                okText="是"
                cancelText="否"
              >
                <a href="#">移除用户</a>
              </Popconfirm>
            )}
          </Space>
        );
      },
    },
  ];

  useEffect(() => {
    getCompanyInfo();
  }, []);

  useEffect(() => {
    getUserList();
  }, [page]);

  const getCompanyInfo = async () => {
    let data = await newAjaxApi({
      url: common.eurekaUrlDic + "/account/base-info/query",
      params: {
        account_id: getCookieNew("accountId"),
      },
      ContentType: "application/json;charset=UTF-8",
    });
    if (data.status == 200) {
      setCompanyInfo(data.data);
    }
  };

  // 获取用户列表
  const getUserList = () => {
    const requestData = {
      ...page,
      ...searchForm.getFieldsValue(),
      roleType: "supplier",
      poSubjectCode: getCookieNew("po_subject_code") || "",
      supplierCode: getCookieNew("supplier_code") || "",
      supplierCompanyCode: getCookieNew("supplier_company_code"),
    };
    axiosPost(
      common.eurekaUrlDic + "/permission/userlist/query",
      requestData,
    ).then((res) => {
      if (res.status === 200) {
        let { datas, page } = res.data;
        setUserList(datas);
        setTotal(page.rowCount || 0);
      }
    });
  };

  const getRoleName = (data) => {
    let rolename = "";
    for (let k = 0; k < data.length; k++) {
      if (data.length === 1) {
        rolename += data[k];
      } else {
        if (k === data.length - 1) {
          rolename += data[k];
        } else {
          rolename += data[k] + "、";
        }
      }
    }
    return rolename;
  };

  // 分页页数改变
  const pageChange = (pageNumber, size) => {
    setPage({
      ...page,
      pageindex: pageNumber,
      pagesize: size,
    });
  };

  // 新增用户的窗口
  const addUser = () => {
    setModalVisiable(!modalVisiable);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const companyItem = (
          companyInfo.account_supplier_company_list || []
        ).find(
          (e) =>
            e.supplier_company_code == getCookieNew("supplier_company_code"),
        );
        const { account_id, ...items } = companyItem;
        axiosPost(common.eurekaUrlDic + "/permission/insert-member-account", {
          ...values,
          password: md5hex(values.psw),
          isPan: "false",
          application: "scs",
          accountSupplierCompanyList: [
            { ...items, account_phone: values.phone },
          ],
          accountEnterpriseList: (companyInfo.account_enterprise_list || [])
            .filter(
              (e) =>
                e.supplier_company_code ==
                getCookieNew("supplier_company_code"),
            )
            .map((e) => {
              const { account_id, account, is_pan, ...accItem } = e;
              return {
                ...accItem,
                is_pan: false,
                account: values.phone,
              };
            }),
        }).then((res) => {
          console.log(res);
          if (res.status === 200) {
            message.success(
              "您账号" + values.phone + "已新增成功，请为其设置角色！",
            );
            form.resetFields();
            addUser();
            setPage({
              ...page,
              pageindex: 1,
            });
          }
        });
      })
      .catch((err) => {
        console.log("表单验证失败", err);
      });
  };

  const handleCancel = () => {
    form.resetFields();
    addUser();
  };

  // 帮助中心弹框
  const helpModalChange = () => {
    setHelpVisiable(!helpVisiable);
  };
  const getVfCode = async (params, fn) => {
    try {
      let res = await axiosPost(
        common.eurekaUrlDic + "/auth/send-verify-code",
        params,
      );
      if (res.data.code == 200) {
        message.success("验证码发送成功，请及时查收");
        if (fn) {
          fn();
        }
      } else {
        message.error("获取验证码失败");
      }
    } catch (err) {
      console.log(err);
    }
  };
  // 手机登录点击获取验证码按钮
  const sendVFcodeByPhone = () => {
    let flag = true;
    let _phone = form.getFieldValue("phone");
    let phone = _phone ? _phone.trim() : "";
    if (!/^1\d{10}$/.test(phone)) {
      flag = false;
      message.warning("手机号未填写或不正确");
    }
    if (phone_cut_count < 60) {
      flag = false;
    }
    if (flag) {
      getVfCode({ send_id: phone, type: 1, sms: true }, () => {
        let intervalPhone = setInterval(() => {
          if (phone_cut_count > 0) {
            setphone_cut_count((num) => {
              return num--;
            });
          } else {
            setphone_cut_count(60);
            clearInterval(intervalPhone);
          }
        }, 1000);
      });
    }
  };

  return (
    <div className="userManage">
      <div className="search">
        <div className="search_head">
          <div className="userList">
            <div className="userList_search">
              <Form form={searchForm} layout="inline">
                <Form.Item name="username">
                  <Input placeholder="用户名" />
                </Form.Item>
                <Form.Item name="reallyname">
                  <Input placeholder="真实姓名" />
                </Form.Item>
                {/* <Form.Item label="状态" name="deleted">
                  <CheckboxGroup options={options} />
                </Form.Item> */}
                <Form.Item>
                  <Button
                    type="primary"
                    shape="round"
                    onClick={() => {
                      setPage({
                        ...page,
                        pageindex: 1,
                      });
                    }}
                  >
                    查询
                  </Button>
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    shape="round"
                    style={{ marginLeft: "16px" }}
                    onClick={addUser}
                  >
                    添加用户
                  </Button>
                </Form.Item>
              </Form>
              <span
                style={{
                  float: "right",
                  color: "#1890ff",
                  cursor: "pointer",
                  marginTop: "10px",
                }}
                onClick={helpModalChange}
              >
                帮助?
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="body">
        {/* 列表 */}
        <Table
          columns={roleColumns}
          dataSource={userList}
          pagination={false}
          bordered={false}
          rowKey={(record) => record.username}
        />
        {/* 分页 */}
        <div className="pagination_wrap">
          <span>共{total || 0}条记录</span>
          <Pagination
            current={page.pageindex}
            onChange={pageChange}
            total={total || 0}
            showSizeChanger
          />
        </div>
      </div>
      <Modal
        title="新增用户"
        open={modalVisiable}
        destroyOnClose={true}
        onCancel={handleCancel}
        footer={[
          <Button key="confirm" type="primary" shape="round" onClick={handleOk}>
            确认
          </Button>,
          <Button key="cancel" shape="round" onClick={handleCancel}>
            取消
          </Button>,
        ]}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="手机号"
            name="phone"
            rules={[{ required: true, message: "手机号为必填项！" }]}
          >
            <Input placeholder="请输入手机号" />
          </Form.Item>
          <Form.Item
            label="验证码"
            name={"verifyCode"}
            rules={[{ required: true, message: "请输入验证码" }]}
          >
            <Input
              size="large"
              maxLength={6}
              placeholder="请输入验证码"
              prefix={<MailOutlined style={{ fontSize: 13 }} />}
              suffix={
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    sendVFcodeByPhone();
                  }}
                  disabled={phone_cut_count < 60}
                  size="large"
                  type="primary"
                  style={{
                    position: "absolute",
                    right: 0,
                    bottom: 0,
                    zIndex: 9,
                  }}
                >
                  {phone_cut_count < 60 ? `${phone_cut_count}s` : "获取验证码"}
                </Button>
              }
            />
          </Form.Item>
          <Form.Item label="真实姓名" name="name">
            <Input placeholder="请输入真实姓名" />
          </Form.Item>
          <Form.Item
            label="密码"
            name="psw"
            rules={[{ required: true, message: "登录密码为必填项！" }]}
          >
            <Input type="password" placeholder="请输入登录密码" />
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="用户管理-帮助中心"
        footer={null}
        open={helpVisiable}
        destroyOnClose={true}
        onCancel={helpModalChange}
      >
        <p>我们会帮您添加用户，只需要您提供手机号，初始密码</p>
        <p>1，点击"添加用户"按钮，输入手机号，登录密码，提交等待审核</p>
        <p>2，点击"设置角色"按钮，为用户绑定角色</p>
        <div style={{ textAlign: "center" }}>
          <Button type="primary" shape="round" onClick={helpModalChange}>
            我知道了
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default withRouter(UserManagement);



// WEBPACK FOOTER //
// ./src/pages/authorityManagement/userManagement.js